import {BrowserModule, HammerModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppComponent} from './app.component';
import {FormsModule} from '@angular/forms';
import {AppRoutingModule} from './app-routing.module';
import {ModifyFormConfigComponent} from './components/modify-form-config/modify-form-config.component';
import {MatLegacyFormFieldModule as MatFormFieldModule} from '@angular/material/legacy-form-field';
import {MatLegacyInputModule as MatInputModule} from '@angular/material/legacy-input';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MydocmaDynamicFormModule} from 'projects/mydocma/dynamic-form/src/lib/dynamic-form.module';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {AngularSplitModule} from 'angular-split';
import { ModuleTranslateLoader} from '@larscom/ngx-translate-module-loader';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import 'hammerjs';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {NgxMatDatetimePickerModule} from '@angular-material-components/datetime-picker';
import {FormPerformanceComponent} from './components/form-performance/form-performance.component';
import {MatLegacyTabsModule as MatTabsModule} from '@angular/material/legacy-tabs';
import {FormInteractionComponent} from './components/form-interaction/form-interaction.component';
import {FillFormComponent} from './components/fill-form/fill-form.component';
import {LayoutsComponent} from './components/layouts/layouts/layouts.component';
import {MatLegacyListModule as MatListModule} from '@angular/material/legacy-list';
import {MatLegacyDialog as MatDialog, MatLegacyDialogModule} from '@angular/material/legacy-dialog';
import {MatLegacySelectModule as MatSelectModule} from '@angular/material/legacy-select';
import {CustomFieldCompanyComponent} from './components/form-interaction/custom-field-company/custom-field-company.component';
import {registerLocaleData} from '@angular/common';
import localeDE from '@angular/common/locales/de';
import localeEN from '@angular/common/locales/en';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatIconModule } from '@angular/material/icon';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {Component1Component} from './test-components/component1/component1.component';
import { ButtonComponentComponent } from './components/test-components/button-component/button-component.component';
export function createTranslateLoader(http: HttpClient) {
    const baseTranslateUrl = './assets/i18n';


    //MIG13: remove fileType
    return new ModuleTranslateLoader(http, {
        modules: [
            {baseTranslateUrl},
            {moduleName: 'form', baseTranslateUrl},
            {moduleName: 'comp-lib', baseTranslateUrl},
        ],
    });
}

@NgModule({
    declarations: [
        AppComponent,
        CustomFieldCompanyComponent,
        FormPerformanceComponent,
        FormInteractionComponent,
        ModifyFormConfigComponent,
        FillFormComponent,
        LayoutsComponent,
        Component1Component,
        ButtonComponentComponent,
    ],
    imports: [
        AppRoutingModule,
        AngularSplitModule,
        BrowserAnimationsModule,
        BrowserModule,
        HttpClientModule,
        FlexLayoutModule,
        FormsModule,
        MatButtonModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatTabsModule,
        MatSelectModule,
        MatLegacyDialogModule,
        MydocmaDynamicFormModule,
        NgxMatDatetimePickerModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient],
            },
        }),
        ScrollingModule
    ],
    exports: [],
    bootstrap: [AppComponent]
})
export class AppModule {

    constructor(
        private translate: TranslateService,
    ) {

        // register locales data for languages
        // important for date format
        registerLocaleData(localeDE, 'de');
        localeEN[10][1] = 'yyyy/MM/dd';
        registerLocaleData(localeEN, 'en');

        this.translate.addLangs(['en', 'de']);
        this.translate.setDefaultLang('de');
        this.translate.use('de');
    }
}
